import BoxWithHeader from "@/common/components/BoxWithHeader"
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder"
import { LogType } from "@/common/types/lead/log.type"
import { formatDateTime } from "@/common/utils/formatters"
import { UserRoundIcon } from "lucide-react"
import { twMerge } from "tailwind-merge"

interface ChangeHistoryProps {
  logs?: LogType[]
  className?: string
  bodyClassName?: string
  dataTestid?: string
}

export const ChangeHistory = ({
  logs,
  className,
  bodyClassName,
  dataTestid,
}: ChangeHistoryProps) => {
  return (
    <BoxWithHeader data-testid="box_history" title="Histórico" className={className} bodyClassName={twMerge('h-[calc((100vh-276px)/2)]', bodyClassName)}>
      {logs?.map((log) => (
        <div key={log.created_at} className="flex flex-col gap-1">
          <div className="flex gap-1">
            <ImageWithPlaceholder
              url={log.changed_by.profile_picture?.url}
              alt={log.changed_by.full_name}
              placeholderIcon={UserRoundIcon}
            />
            <p data-testid={dataTestid} className="text-xs">{log.changed_by.full_name}</p>
          </div>
          <p data-testid="display_name_history">{log.message}</p>
          {log.created_at && (
            <p className="font-light italic text-[10px]">{formatDateTime(new Date(log.created_at))}</p>
          )}
      </div>
      ))}
    </BoxWithHeader>
  )
}
